
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jdZ9N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TrialBannerEntrypointContainer", () => $51cdd91c04795705$export$b066973ab0562ebb);
$parcel$export(module.exports, "default", () => $51cdd91c04795705$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9dMoo = parcelRequire("9dMoo");
const $51cdd91c04795705$export$b066973ab0562ebb = ({ props: { isProjectSimplified: isProjectSimplified } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dMoo.TrialBanner), {
        isProjectSimplified: isProjectSimplified
    });
var $51cdd91c04795705$export$2e2bcd8739ae039 = $51cdd91c04795705$export$b066973ab0562ebb;

});
parcelRegister("9dMoo", function(module, exports) {

$parcel$export(module.exports, "TrialBanner", () => $b131cb2d1211eb11$export$f80b76dcd28c9075);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $1n6uL = parcelRequire("1n6uL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $gd0Sp = parcelRequire("gd0Sp");

var $bl5uD = parcelRequire("bl5uD");

var $fmbCP = parcelRequire("fmbCP");

var $61COh = parcelRequire("61COh");
const $b131cb2d1211eb11$var$background = `linear-gradient(225deg, ${"var(--ds-background-accent-purple-subtlest, #F3F0FF)"} 0%, ${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"} 51.89%, ${"var(--ds-background-accent-teal-subtlest, #E3FAFC)"} 100%)`;
const $b131cb2d1211eb11$var$BANNER_CLOSE_BUTTON_TEST_ID = 'business-trial-banner.ui.close-button';
const $b131cb2d1211eb11$export$f80b76dcd28c9075 = ({ isProjectSimplified: isProjectSimplified })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [bannerClosed, setBannerClosed] = (0, $eUqFw.useState)(false);
    const [modalClosed, setModalClosed] = (0, $eUqFw.useState)(true);
    const [billingSystem, setBillingSystem] = (0, $eUqFw.useState)(null);
    const { shouldRenderExperiment: shouldRenderExperiment, clearCache: clearCache } = (0, $bl5uD.useTrialBannerExperiment)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        setBillingSystem(tenantContext.productEntitlementDetails?.['jira-software']?.billingSourceSystem === 'CCP' ? 'CCP' : 'HAMS');
    }, [
        tenantContext
    ]);
    const onClose = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'jwmMonetisationModalDismiss', {
            projectType: isProjectSimplified ? 'TMP' : 'CMP',
            billingType: billingSystem
        });
        setModalClosed(true);
    };
    const handleBannerClick = (_e, analyticsEvent)=>{
        setModalClosed(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jwmMonetisationTryPremium', {
            projectType: isProjectSimplified ? 'TMP' : 'CMP',
            billingSystem: billingSystem
        });
    };
    const handleDismissClick = (_e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jwmMonetisationBannerDismiss', {
            projectType: isProjectSimplified ? 'TMP' : 'CMP',
            billingSystem: billingSystem
        });
        setBannerClosed(true);
        if ((0, $eI5EY.fg)('jwm_create_project_from_sample')) clearCache();
    };
    return shouldRenderExperiment && !bannerClosed && billingSystem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b131cb2d1211eb11$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "business-trial-banner.ui.premium-upgrade",
        padding: "space.300",
        xcss: $b131cb2d1211eb11$var$premiumUpgradeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        spread: "space-between",
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b131cb2d1211eb11$var$Content, null, formatMessage((0, $fmbCP.messages).premiumTrialContentComplexspork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $fmbCP.messages).closeBannerAriaLabel),
        appearance: "subtle-link",
        onClick: handleDismissClick,
        "data-testId": $b131cb2d1211eb11$var$BANNER_CLOSE_BUTTON_TEST_ID,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "",
            size: "small" // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<T> & Readonly<GlyphProps>'.ts(2769)
            ,
            className: (0, $7JEyt.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
            ])
        }),
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i7vkz _1bsb7vkz"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        grow: "fill",
        alignBlock: "end",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleBannerClick,
        appearance: "primary",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: ""
        })
    }, formatMessage((0, $fmbCP.messages).premiumTrialCta))))), !modalClosed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $61COh.FreeToPremiumModal), {
        onClose: onClose,
        billingSystem: billingSystem,
        isProjectSimplified: isProjectSimplified
    })) : null;
};
var $b131cb2d1211eb11$export$2e2bcd8739ae039 = $b131cb2d1211eb11$export$f80b76dcd28c9075;
const $b131cb2d1211eb11$var$styles2 = null;
const $b131cb2d1211eb11$var$styles = null;
const $b131cb2d1211eb11$var$premiumUpgradeStyles = (0, $1ZAYh.xcss)({
    background: $b131cb2d1211eb11$var$background,
    width: '100%',
    paddingRight: 'space.200',
    paddingTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b131cb2d1211eb11$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _syaz8a6j",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b131cb2d1211eb11$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bl5uD", function(module, exports) {

$parcel$export(module.exports, "useTrialBannerExperiment", () => $2f2e2bff29f1d160$export$c5339fca7004ca2e);

var $eUqFw = parcelRequire("eUqFw");

var $bHRuU = parcelRequire("bHRuU");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $jRj3P = parcelRequire("jRj3P");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $j3FUN = parcelRequire("j3FUN");
var $gd0Sp = parcelRequire("gd0Sp");

var $dFbiN = parcelRequire("dFbiN");
const $2f2e2bff29f1d160$var$PACKAGE_NAME = 'jira-business.monetisation-banner-experiment';
const $2f2e2bff29f1d160$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $2f2e2bff29f1d160$export$326d13718bc80d3c = (billingSourceSystem, trialEndTime)=>billingSourceSystem === 'HAMS' && trialEndTime && (0, $bHRuU.default)(new Date(), $2f2e2bff29f1d160$export$9dbbf537dffaafc7(trialEndTime)) < 14;
const $2f2e2bff29f1d160$export$c5339fca7004ca2e = ()=>{
    const clearCache = (0, $eUqFw.useCallback)(()=>{
        if ((0, $eI5EY.fg)('jwm_create_project_from_sample')) (0, $jRj3P.memoizedFetchSiteUserPersonalization).clear();
    }, []);
    // All of the below functions are only used by `shouldRenderExperiment`, but are
    // placed outside it as they involve React hooks.
    // Licensing
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const { software: edition } = (0, $ab6rA.useAppEditions)();
    // Billing
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const entitlementDetails = productEntitlementDetails?.['jira-software'];
    // If billingSourceSystem is not set, it is HAMS.
    const billingSourceSystem = entitlementDetails?.billingSourceSystem ?? 'HAMS';
    const { entitlementId: entitlementId } = entitlementDetails || {};
    const inTrialOrGracePeriod = (0, $eUqFw.useMemo)(()=>entitlementDetails?.trialEndTime ? $2f2e2bff29f1d160$export$326d13718bc80d3c(billingSourceSystem, entitlementDetails.trialEndTime) : false, [
        billingSourceSystem,
        entitlementDetails?.trialEndTime
    ]);
    const inHAMSTrialOrGracePeriod = billingSourceSystem === 'CCP' ? false : inTrialOrGracePeriod;
    const [shouldRenderExperiment, setShouldRenderExperiment] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        let cancelled = false;
        const userId = atlassianAccountId ?? '';
        const hasJSWLicence = licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE];
        const hasJSWFreeTierLicence = edition === (0, $6WXNs.FREE_EDITION);
        const hasExplicitJWMLicence = licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS)?.JIRA_CORE];
        const initialConditions = !!cloudId && isSiteAdmin && !!userId && hasJSWLicence && hasJSWFreeTierLicence && !hasExplicitJWMLicence && !inHAMSTrialOrGracePeriod;
        if (!initialConditions) {
            setShouldRenderExperiment(false);
            return;
        }
        const traitName = 'jira_workmanagement_ui_jwmmonetisationbannerdismiss_clicked_last';
        const traitCondition = (trait)=>trait?.value ? (0, $bHRuU.default)(new Date(), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $2f2e2bff29f1d160$export$9dbbf537dffaafc7(trait?.value ?? 0)) > 7 : true; // if the trait does not exist, user is still eligible for enrolment.
        const checkWhetherBannerDismissed = (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: userId
        }).then((value)=>{
            if (cancelled) return null;
            const trait = value.find(({ name: name })=>name === traitName);
            return traitCondition(trait);
        }, ()=>false);
        const checkWhetherIsBillingAdmin = (0, $dFbiN.getBillingInformation)({
            cloudId: cloudId,
            userId: userId,
            billingSourceSystem: billingSourceSystem,
            entitlementId: entitlementId,
            isSiteAdmin: isSiteAdmin
        }).then((billingInformation)=>{
            if (cancelled) return null;
            return billingSourceSystem === 'CCP' ? billingInformation.isBillingAdmin !== false || billingInformation.invoiceable !== false : isSiteAdmin;
        }, (error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'JwmMonetizationTrialBannerExperimentPipeline',
                    packageName: $2f2e2bff29f1d160$var$PACKAGE_NAME,
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return false;
        });
        Promise.all([
            checkWhetherBannerDismissed,
            checkWhetherIsBillingAdmin
        ]).then((values)=>{
            if (values.some((value)=>value == null)) return;
            if (values.every(Boolean)) setShouldRenderExperiment((0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', 'variation'));
            else setShouldRenderExperiment(false);
        });
        // Guarding against race conditions through `cancelled`, when this `useEffect` is
        // being run more than once.
        return ()=>{
            cancelled = true;
        };
    }, [
        atlassianAccountId,
        billingSourceSystem,
        cloudId,
        edition,
        entitlementId,
        inHAMSTrialOrGracePeriod,
        isSiteAdmin,
        licensedProducts
    ]);
    return {
        shouldRenderExperiment: shouldRenderExperiment,
        clearCache: clearCache
    };
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("dFbiN", function(module, exports) {

$parcel$export(module.exports, "getBillingInformation", () => $ef333e8985acd015$export$8299b86bb18aafc1);

var $jRj3P = parcelRequire("jRj3P");

var $duEtD = parcelRequire("duEtD");


var $lJf2o = parcelRequire("lJf2o");
const $ef333e8985acd015$export$8299b86bb18aafc1 = async ({ cloudId: cloudId, userId: userId, billingSourceSystem: billingSourceSystem, entitlementId: entitlementId, isSiteAdmin: isSiteAdmin })=>{
    let invoiceable = null;
    let transactionAccountId = null;
    let invoiceGroupId = null;
    let isBillingAdmin = null;
    if (!cloudId) throw new Error('empty cloudId');
    if (billingSourceSystem === 'CCP') {
        if (!entitlementId) throw new Error('empty entitlementId');
        if (!userId) throw new Error('empty userId');
        // Billing Admins trait checks whether user is CCP billing admin on current site
        // This check helps us to control the load on CCP services and billing status will be checked
        // again inside CCP service to make sure that billing admin permission was not revoked since last trait refresh
        const traits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: userId
        });
        const ccpBillingAdminTrait = traits?.find((trait)=>trait.name === (0, $02de2fde6cf2ac65$export$aed5883bf63650a5));
        if (ccpBillingAdminTrait?.value) {
            const response = await (0, $duEtD.getBillingInformationCCP)(entitlementId);
            invoiceable = response.invoiceable;
            // Billing admin check is skipped if site is not in trial/grace period so we have to make sure that null value
            // is persisted here so we can evaluated whether value is intetionally false or that check was just skipped
            isBillingAdmin = response.billingAdmins && !!response.billingAdmins.find(({ id: id = null })=>id === userId);
            transactionAccountId = response.transactionAccountId;
            invoiceGroupId = response.invoiceGroupId;
        } else // Explicitly marking value to false
        isBillingAdmin = false;
    // If billing source system is HAMS all site admins are also billing admin so all we need to do is simple siteAdmin check
    // all isBillingAdmin values are being explicitly set
    } else if (isSiteAdmin) {
        const response = await (0, $lJf2o.getBillingInformationHAMS)(cloudId);
        invoiceable = response.invoiceable;
        isBillingAdmin = true;
    } else isBillingAdmin = false;
    return {
        invoiceable: invoiceable,
        transactionAccountId: transactionAccountId,
        invoiceGroupId: invoiceGroupId,
        isBillingAdmin: isBillingAdmin
    };
};

});
parcelRegister("duEtD", function(module, exports) {

$parcel$export(module.exports, "getBillingInformationCCP", () => $04df51d321e3b1dd$export$bfb745c360035d87);

var $5iWql = parcelRequire("5iWql");

var $lRmyA = parcelRequire("lRmyA");
const $04df51d321e3b1dd$var$fetchEntitlementDetails = (entitlementId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $04df51d321e3b1dd$var$fetchBillingAdmins = (transactionAccountId)=>(0, $lRmyA.performGetRequest)('/gateway/api/ccp/api/v1/billing-admins', {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
const $04df51d321e3b1dd$var$fetchInvoiceGroupStatus = (transactionAccountId, invoiceGroupId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/ccp/api/v1/invoice-groups/${invoiceGroupId}/status`, {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
const $04df51d321e3b1dd$var$memoizedFetchEntitlementsDetails = (0, $5iWql.default)($04df51d321e3b1dd$var$fetchEntitlementDetails);
const $04df51d321e3b1dd$var$memoizedFetchInvoiceGroupsStatus = (0, $5iWql.default)($04df51d321e3b1dd$var$fetchInvoiceGroupStatus);
const $04df51d321e3b1dd$var$memoizedFetchBillingAdmins = (0, $5iWql.default)($04df51d321e3b1dd$var$fetchBillingAdmins);
const $04df51d321e3b1dd$export$bfb745c360035d87 = async (entitlementId)=>{
    // get the entitlement details
    const entitlementDetails = await $04df51d321e3b1dd$var$memoizedFetchEntitlementsDetails(entitlementId);
    const transactionAccountId = entitlementDetails?.transactionAccountId;
    const invoiceGroupId = entitlementDetails?.subscription?.invoiceGroupId ?? null;
    if (!transactionAccountId) throw new Error('empty transactionAccountId');
    const invoiceGroupStatusPromise = transactionAccountId && invoiceGroupId ? $04df51d321e3b1dd$var$memoizedFetchInvoiceGroupsStatus(transactionAccountId, invoiceGroupId) : Promise.resolve(null);
    const billingAdminsPromise = $04df51d321e3b1dd$var$memoizedFetchBillingAdmins(transactionAccountId);
    // Invoiceability and billing admin checks could happen in parallel to improve pill performance
    const [invoiceGroupStatusResponse, billingAdminsResponse] = await Promise.all([
        invoiceGroupStatusPromise,
        billingAdminsPromise
    ]);
    const invoiceable = !!invoiceGroupStatusResponse?.invoiceable || false;
    const billingAdmins = billingAdminsResponse?.data || null;
    return {
        transactionAccountId: transactionAccountId,
        invoiceGroupId: invoiceGroupId,
        invoiceable: invoiceable,
        billingAdmins: billingAdmins
    };
};

});

// https://data-portal.internal.atlassian.com/targeting/traits/9b3a033f-c94a-4fb4-b3cb-ac766d791a49
const $02de2fde6cf2ac65$export$aed5883bf63650a5 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("lJf2o", function(module, exports) {

$parcel$export(module.exports, "getBillingInformationHAMS", () => $82621d4565612977$export$17f516f24239549);

var $5iWql = parcelRequire("5iWql");

var $lRmyA = parcelRequire("lRmyA");
const $82621d4565612977$var$fetchBillingDetails = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/billing-details`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $82621d4565612977$var$memoizedFetchBillingDetails = (0, $5iWql.default)($82621d4565612977$var$fetchBillingDetails);
const $82621d4565612977$export$17f516f24239549 = async (cloudId)=>{
    if (!cloudId) throw new Error('empty cloudId');
    const billingDetails = await $82621d4565612977$var$memoizedFetchBillingDetails(cloudId);
    return {
        invoiceable: Boolean(billingDetails?.paymentMethod && billingDetails?.paymentMethod !== 'NO_DETAILS')
    };
};

});



parcelRegister("fmbCP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f80c28f63657ad5c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f80c28f63657ad5c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    closeBannerAriaLabel: {
        "id": "business-trial-banner.close-banner-aria-label",
        "defaultMessage": "Close premium upgrade banner"
    },
    premiumSuccessDescription: {
        "id": "business-trial-banner.premium-success-description",
        "defaultMessage": "At anytime before {formattedTrialEndDate}, add a payment method to stay on the Premium plan."
    },
    premiumSuccessTitle: {
        "id": "business-trial-banner.premium-success-title",
        "defaultMessage": "You\u2019ve got 14 days of Premium"
    },
    premiumTrialContentComplexspork: {
        "id": "business-trial-banner.premium-trial-content-complexspork",
        "defaultMessage": "Unlock advanced features for cross-functional collaboration with Jira Premium."
    },
    premiumTrialCta: {
        "id": "business-trial-banner.premium-trial-cta",
        "defaultMessage": "Try Premium"
    }
});

});

parcelRegister("61COh", function(module, exports) {

$parcel$export(module.exports, "FreeToPremiumModal", () => $d933d92b1cefb935$export$967bdf7074c2fc52);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $boSVF = parcelRequire("boSVF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $jukXg = parcelRequire("jukXg");

var $6Vk2J = parcelRequire("6Vk2J");

var $iaq8a = parcelRequire("iaq8a");

var $3xncV = parcelRequire("3xncV");
const $d933d92b1cefb935$export$967bdf7074c2fc52 = ({ onClose: onClose, billingSystem: billingSystem, isProjectSimplified: isProjectSimplified })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: billingPageData } = (0, $jukXg.useGetJswPremiumBillingUrl)();
    const openBillingPage = (e, analyticsEvent)=>{
        e.preventDefault();
        if (billingPageData?.billingPageUrl) {
            window.open(billingPageData.billingPageUrl, '_blank', 'noreferrer');
            onClose();
        }
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jwmMonetisationModalTryNow', {
            projectType: isProjectSimplified ? 'TMP' : 'CMP',
            billingSystem: billingSystem
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: 720,
        autoFocus: false,
        shouldScrollInViewport: true,
        testId: "business-trial-banner.ui.modal.free-to-premium-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d933d92b1cefb935$var$BodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d933d92b1cefb935$var$CoverImage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d933d92b1cefb935$var$BodyPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $3xncV.default).tryAcrossProductsSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $3xncV.default).startATrialSpork, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaq8a.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d933d92b1cefb935$var$ButtonGroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose
    }, formatMessage((0, $3xncV.default).maybeLater)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        isLoading: billingPageData?.billingPageUrl === undefined,
        href: billingPageData?.billingPageUrl,
        onClick: openBillingPage,
        target: "_blank"
    }, formatMessage((0, $3xncV.default).tryPremium))))));
};
var $d933d92b1cefb935$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d933d92b1cefb935$export$967bdf7074c2fc52;
const $d933d92b1cefb935$var$BodyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d933d92b1cefb935$var$CoverImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gswazn": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($6Vk2J))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _i0dlo8uj _11q77rqo _vchhusvi _2rkog0na",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d933d92b1cefb935$var$BodyPanel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _i0dl78o8 _1yt41jfw _vchhusvi _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d933d92b1cefb935$var$ButtonGroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahusic _zulputpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jukXg", function(module, exports) {

$parcel$export(module.exports, "useGetJswPremiumBillingUrl", () => $2ea2b92669655273$export$13ec9cca8642cc78);

var $eUqFw = parcelRequire("eUqFw");

var $bW292 = parcelRequire("bW292");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $2OdyW = parcelRequire("2OdyW");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $3e9vj = parcelRequire("3e9vj");
var $gd0Sp = parcelRequire("gd0Sp");

const $2ea2b92669655273$export$394e5f6e2c43fe80 = {
    prod: 'https://admin.atlassian.com',
    dev: 'https://admin.stg.atlassian.com',
    local: 'https://admin.stg.atlassian.com',
    staging: 'https://admin.stg.atlassian.com'
};
const $2ea2b92669655273$export$d891c31466b6cb8d = {
    prod: (0, $bW292.getATLContextUrl)('admin'),
    dev: 'https://admin.stg.atlassian.com',
    local: 'https://admin.stg.atlassian.com',
    staging: 'https://admin.stg.atlassian.com'
};
const $2ea2b92669655273$var$getCcpTransactionAccountId = async (entitlementId)=>{
    const entitlementDetails = await (0, $2OdyW.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};
const $2ea2b92669655273$var$EDITION_KEY = {
    STANDARD_EDITION: (0, $6WXNs.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $6WXNs.PREMIUM_EDITION_KEY)
};
const $2ea2b92669655273$export$13ec9cca8642cc78 = ()=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const environment = (0, $3e9vj.useEnvironment)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    (0, $eUqFw.useEffect)(()=>{
        const loadBillingInfo = async ()=>{
            try {
                const productKey = (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
                const isUsingCcp = tenantContext.productEntitlementDetails?.['jira-software']?.billingSourceSystem === 'CCP';
                const referrerKey = 'jwm';
                const commerceProductKey = `${productKey}.ondemand`;
                const entitlementId = tenantContext.productEntitlementDetails?.[productKey]?.entitlementId;
                const edition = $2ea2b92669655273$var$EDITION_KEY.PREMIUM_EDITION;
                const adminHubBaseUrl = (0, $eI5EY.fg)('jwm_fedramp_endpoint_update') ? $2ea2b92669655273$export$d891c31466b6cb8d[environment] : $2ea2b92669655273$export$394e5f6e2c43fe80[environment];
                if (isUsingCcp) {
                    // CCP Billing System
                    if (!entitlementId) throw new Error('Empty entitlement ID');
                    const ccpTransactionAccountId = await $2ea2b92669655273$var$getCcpTransactionAccountId(entitlementId);
                    const ccpBaseUrl = `${adminHubBaseUrl}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}`;
                    setBillingPageUrl(`${ccpBaseUrl}&offeringName=${edition}`);
                } else // HAMS Billing System
                setBillingPageUrl(`${adminHubBaseUrl}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${edition}`);
            } catch (e) {
                setError(e);
                (0, $guiFP.default)({
                    meta: {
                        id: 'useGetJswPremiumBillingUrl',
                        packageName: (0, $ebba456e6ace08b3$export$b8b9d90f9e5bd72b),
                        teamName: 'jira-warepil'
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        environment,
        orgId,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

const $ebba456e6ace08b3$export$2fa4e95d1c6e7b0f = 'jira_workmanagement_ui_jwmmonetisationbannerdismiss_clicked_last';
const $ebba456e6ace08b3$export$b8b9d90f9e5bd72b = 'jiraBusinessProgramMoonTrialBanner';
const $ebba456e6ace08b3$export$5200514808277ba7 = 'showJWMPremiumUpgradeSuccessFlag';


parcelRegister("6Vk2J", function(module, exports) {
module.exports = new URL("edition-awareness-illustration.cf1dba8c.svg", import.meta.url).toString();

});

parcelRegister("iaq8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db129d3190e430c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4nce6 = parcelRequire("4nce6");

var $1vuAp = parcelRequire("1vuAp");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $78led = parcelRequire("78led");

var $5JgJ2 = parcelRequire("5JgJ2");

var $juNj5 = parcelRequire("juNj5");

var $ed3vn = parcelRequire("ed3vn");
const $5db129d3190e430c$var$FALLBACK_COLOR = '#0055CC';
const $5db129d3190e430c$export$ccb2870a847830f2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const listItems = [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
                primaryColor: `var(--ds-link-pressed, ${$5db129d3190e430c$var$FALLBACK_COLOR})`,
                label: ""
            }),
            header: (0, $ed3vn.default).crossTeamHeadingComplexspork,
            description: (0, $ed3vn.default).crossTeamDescriptionComplexspork
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
                size: "medium",
                label: ""
            }),
            header: (0, $ed3vn.default).aiHeadingComplexspork,
            description: (0, $ed3vn.default).aiFeaturesDescriptionComplexspork
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $juNj5.AutomationIcon), {
                primaryColor: `var(--ds-link-pressed, ${$5db129d3190e430c$var$FALLBACK_COLOR})`,
                label: ""
            }),
            header: (0, $ed3vn.default).higherAutomationHeadingComplexspork,
            description: (0, $ed3vn.default).higherAutomationDescriptionComplexspork
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                primaryColor: `var(--ds-link-pressed, ${$5db129d3190e430c$var$FALLBACK_COLOR})`,
                label: ""
            }),
            header: (0, $ed3vn.default).greaterAdminControlsHeadingComplexspork,
            description: (0, $ed3vn.default).muchMoreDescriptionComplexspork
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5db129d3190e430c$var$List, null, listItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5db129d3190e430c$var$ListItem, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5db129d3190e430c$var$IconBox, null, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $5db129d3190e430c$var$contentContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5db129d3190e430c$var$Header, null, formatMessage(item.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5db129d3190e430c$var$Content, null, formatMessage(item.description))))));
};
var $5db129d3190e430c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5db129d3190e430c$export$ccb2870a847830f2;
const $5db129d3190e430c$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _1yt4ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5db129d3190e430c$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1fw0",
            __cmplp.className
        ])
    });
});
const $5db129d3190e430c$var$ListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulppxbi _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $5db129d3190e430c$var$IconBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _bfhkavxe _2rkopd34 _1e0c1txw _4t3i1jfw _1bah1h6o _19pk1b66 _1tke1jfw _1ul91jfw _1bsb1jfw",
            __cmplp.className
        ])
    });
});
const $5db129d3190e430c$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5db129d3190e430c$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});

parcelRegister("78led", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $c929eac1624d8a26$export$762da6f7f5ace732);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");
const $c929eac1624d8a26$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u')) {
        iconAccentBlueB200 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
        textAccentBlueB400 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
    } else if (props.isDisabled) {
        iconAccentBlueB200 = `var(--ds-icon-accent-gray, ${(0, $PdmhA).N300})`;
        textAccentBlueB400 = `var(--ds-text-accent-gray, ${(0, $PdmhA).N300})`;
    } else {
        iconAccentBlueB200 = `var(--ds-icon-accent-blue, ${(0, $PdmhA).B200})`;
        textAccentBlueB400 = `var(--ds-text-accent-blue, ${(0, $PdmhA).B400})`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

parcelRegister("juNj5", function(module, exports) {

$parcel$export(module.exports, "AutomationIcon", () => $e85c4110a3ebb4c0$export$6514915f794aa404);

var $eUqFw = parcelRequire("eUqFw");
const $e85c4110a3ebb4c0$export$6514915f794aa404 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Lightning (Beta)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "Vector 3",
        d: "M14 5L10 19",
        stroke: props.primaryColor,
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "Vector 4",
        d: "M14 5L7 12H17L10 19",
        stroke: props.primaryColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));

});

parcelRegister("ed3vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d178de8100dc403d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d178de8100dc403d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    crossTeamHeadingComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.cross-team-heading-complexspork",
        "defaultMessage": "Cross-team planning and tracking"
    },
    crossTeamDescriptionComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.cross-team-description-complexspork",
        "defaultMessage": "Create a Plan to schedule work, map dependencies, and report progress across multiple teams and projects."
    },
    aiHeadingComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.ai-heading-complexspork",
        "defaultMessage": "Atlassian Intelligence"
    },
    aiFeaturesDescriptionComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.ai-features-description-complexspork",
        "defaultMessage": "Accelerate work and minimize distractions with AI-powered search and editing."
    },
    higherAutomationHeadingComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.higher-automation-heading-complexspork",
        "defaultMessage": "Higher automation limits"
    },
    higherAutomationDescriptionComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.higher-automation-description-complexspork",
        "defaultMessage": "Freely leverage global automation to standardize best practices across your organization."
    },
    greaterAdminControlsHeadingComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.greater-admin-controls-heading-complexspork",
        "defaultMessage": "Greater admin controls"
    },
    muchMoreDescriptionComplexspork: {
        "id": "business-trial-banner.modal.benefits-list.much-more-description-complexspork",
        "defaultMessage": "Ensure a smooth and secure experience for end users with sandbox, release tracks, admin insights, IP allow listing, and more."
    }
});

});


parcelRegister("3xncV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb2a9eeef9784d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3cb2a9eeef9784d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tryAcrossProductsSpork: {
        "id": "business-trial-banner.modal.try-across-products-spork",
        "defaultMessage": "Try Premium features for free "
    },
    startATrialSpork: {
        "id": "business-trial-banner.modal.start-a-trial-spork",
        "defaultMessage": "Start a <b>30-day trial</b> of Jira Premium to unlock advanced project management features for all your teams."
    },
    maybeLater: {
        "id": "business-trial-banner.modal.maybe-later",
        "defaultMessage": "Maybe later"
    },
    tryPremium: {
        "id": "business-trial-banner.modal.try-premium",
        "defaultMessage": "Try now"
    }
});

});





//# sourceMappingURL=async-trial-banner.8d51725f.js.map
